import styled from 'styled-components';

import { SlideshowContainer } from './slideshow-view.style';
import { grey4 } from 'approot/shared/styles/colours.style';

export const SlideshowEditContainer = styled(SlideshowContainer)`
  border: 1px solid ${grey4};
`;
